<template>
  <auth-template>
    <template v-slot:main>

      <div class="form">
        <div class="head">
          <h3 class="title">Вход в личный кабинет</h3>
          <p class="sub_title_text">Введите корректные данные для авторизации на сайте</p>
        </div>

        <div class="body">

          <form>
          <standart-filed
              id="email" title="Электронная почта" type="text" placeholder="Введите почту"
              :value="form.email" @updated="form.email = $event"
              :error-text="errors.email"
          >
          </standart-filed>

          <standart-filed
              id="password" title="Пароль" type="password" placeholder="Введите пароль"
              :value="form.password" @updated="form.password = $event"
              :error-text="errors.password"
          >
          </standart-filed>
          </form>

          <div class="row rm_fog">
            <div class="confirm">
              <standart-checkbox
                  :checked="form.remember"
                  @change="form.remember = $event"
              >
                <template v-slot:text_content>
                Запомнить меня
              </template></standart-checkbox>
            </div>
            <span class="bl" @click="$router.push({name:'forgot'})">Забыли пароль?</span>
          </div>

          <div class="share_error_b" v-show="error != ''">
            <p v-html="error"></p>
          </div>

          <div class="bottom">
            <standart-button @click="login()" style_type="prime" text="Войти"></standart-button>
            <p v-if="false">Вход по <span class="bl">номеру телефона</span></p>
            <p v-if="false">У вас нет учетной записи? <span
                @click="$router.push({name:'registration'})" class="bl">Зарегистрироваться</span>
            </p>
          </div>

          <!--
          <br>
          <div class="bottom">
            <standart-button @click="testWS()" style_type="prime" text="TEST WS"></standart-button>
            <standart-filed id="ssss"></standart-filed>
          </div>
          -->

        </div>
      </div>

    </template>
  </auth-template>
</template>

<script>
// @ is an alias to /src
import AuthTemplate from '@/components/AuthTemplate.vue';
import StandartFiled from "@/components/share/StandartField";
import StandartCheckbox from "@/components/share/StandartCheckbox";
import StandartButton from "@/components/share/StandartButton";
import axios from "axios";



export default {
  name: 'LoginView',
  components: {
    StandartButton,
    StandartCheckbox,
    StandartFiled,
    AuthTemplate,
  },
  data() {
    return{
      form : {
        email : "",
        password : "",
        remember: false
      },
      errors: {
        email : "",
        password : "",
      },
      error : ""
    }
  },
  methods : {
    testWS : function() {
      let mess = document.getElementById("ssss").value;
      window.socket.send(mess);
    },
    login: async function() {

      if(!this.validate()) {
        return;
      }

      try {

        const bodyFormData = new FormData;

        for(let field in this.form) {
          bodyFormData.append(field, this.form[field]);
        }

        let res = await axios.post(window.api_url + 'auth/login', bodyFormData);

        if (res.data.status === "fail") {
          this.error = res.data.message;
          return;
        }

        if (res.data.status  === 'success') {
          console.log("success");

          this.$router.push({name:'main',params: {tab: "main"}});
        }
      } catch (e) {
        console.log(e);
      } finally {
        console.log("end");
      }

    },
    validate: function() {
      for(let field in this.form) {this.errors[field] = "";}
      this.error = "";

      let validation = true;

      const EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;

      for(let field in this.form) {
        if(field == "email" || field == "password") {
          if(this.form[field] == "") {
            this.errors[field] = "Обязательное поле";
            validation = false;
          }
        }
        if(field == "email"){
          if(!EMAIL_REGEXP.test(this.form[field]) && this.form[field] != "") {
            this.errors[field] = "Электронная почта введена некорректно";
            validation = false;
          }
        }
      }

      return validation;
    },
    /*multi_region_login : async function(bodyFormData) {
      if(window.location.origin == "https://stp62.ru")
      {
        await axios.post('https://71stp.ru/api/v1/auth/login', bodyFormData)
      }
      else if(window.location.origin == "https://71stp.ru")
      {
        await axios.post('https://stp62.ru/api/v1/auth/login', bodyFormData)
      }
    }*/
  }
}
</script>


<style scoped>

.standart_field.email {
  margin-bottom: 18px;
}

.standart_field.password {
  margin-bottom: 14px;
}

.share_error_b p {
  color: var(--Red, #FA4B61);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 136%;
}

.row.rm_fog {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
}

.bottom {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.bottom p {
  color: var(--Gray, #656565);
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 0px;
  margin: 0px;
  text-align: center;
}

.bl {
  color: var(--Blue, #1B78BC);
  text-align: right;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  cursor: pointer;
}


/*MOBILE*/
@media (max-width: 1250px)
{
  .standart_field.email {
    margin-bottom: 14px;
  }

  .standart_field.password {
    margin-bottom: 14px;
  }

  .row.rm_fog {
    margin-bottom: 20px;
  }

  .bottom {
    gap: 12px;
  }
}
</style>
